var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-tag-manager',{attrs:{"tags":_vm.tags,"list":_vm.tagOptions,"list-value-field":"value","color-value-field":"colors","loaded-per-time":1,"tag-preloader":_vm.tagPreloader},on:{"storeTag":_vm.testStoreData,"attachTag":_vm.attachTag,"detachTag":_vm.detachTag}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }